import { Directive, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { getInternalAppRoute, isNativeApp } from '../../../helpers/in-app-link.helper';

/**
 * Applied to containers that render trusted post HTML via [innerHTML]. In the
 * native app, intercepts clicks on links that point back into School Connect and
 * routes them through the Angular Router instead of letting the WebView open a
 * new window (the default for cross-origin / target="_blank" anchors — the app
 * WebView runs on a different origin than app.nhaschools.com, so our own links
 * are treated as external).
 *
 * External links and the web build are left untouched (web keeps its new-tab
 * behavior).
 */
@Directive({
  selector: '[appInAppLinks]',
  standalone: true,
})
export class InAppLinksDirective {
  constructor(private router: Router) {}

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    if (!isNativeApp()) return;

    const anchor = (event.target as HTMLElement | null)?.closest?.('a');
    if (!anchor) return;

    // Prefer the route tagged by preparePostHtml; fall back to parsing the href
    // so the directive still works on any internal link, tagged or not.
    const route =
      anchor.getAttribute('data-inapp-route') ??
      getInternalAppRoute(anchor.getAttribute('href'));
    if (!route) return; // external link — allow default (opens outside the app)

    event.preventDefault();
    this.router.navigateByUrl(route);
  }
}
